import { Table } from "@/features/Table";
import { type DelayedJobs, delayed_jobs_columns } from "./columns";
import { type FilterDelayedJobsSchema, FilterDelayedJobs } from "./filter";

const client = "legacy-quantilia";
const table_name = "delayed_jobs";

export const DelayedJobTable = () => {
  return (
    <Table<DelayedJobs, FilterDelayedJobsSchema>
      label="Delayed Jobs"
      client={client}
      table_name={table_name}
      columns={delayed_jobs_columns}
      filter={<FilterDelayedJobs />}
      disable_translations_request={true}
    />
  );
};
